export var SessionGapDirection;
(function (SessionGapDirection) {
    SessionGapDirection["up"] = "up";
    SessionGapDirection["down"] = "down";
})(SessionGapDirection || (SessionGapDirection = {}));
export var SessionGapKind;
(function (SessionGapKind) {
    SessionGapKind["none"] = "none";
    SessionGapKind["partialUp"] = "partialUp";
    SessionGapKind["partialDown"] = "partialDown";
    SessionGapKind["fullUp"] = "fullUp";
    SessionGapKind["fullDown"] = "fullDown";
})(SessionGapKind || (SessionGapKind = {}));
export var SessionGapZoneType;
(function (SessionGapZoneType) {
    SessionGapZoneType["closeGap"] = "closeGap";
    SessionGapZoneType["fullGap"] = "fullGap";
})(SessionGapZoneType || (SessionGapZoneType = {}));
export var SessionGapStatus;
(function (SessionGapStatus) {
    SessionGapStatus["active"] = "active";
    SessionGapStatus["filled"] = "filled";
    SessionGapStatus["expired"] = "expired";
})(SessionGapStatus || (SessionGapStatus = {}));
export var SessionGapEventType;
(function (SessionGapEventType) {
    SessionGapEventType["gapUpCreated"] = "gapUpCreated";
    SessionGapEventType["gapDownCreated"] = "gapDownCreated";
    SessionGapEventType["closeGapFirstTouch"] = "closeGapFirstTouch";
    SessionGapEventType["closeGapMidpointTouched"] = "closeGapMidpointTouched";
    SessionGapEventType["closeGapFilled"] = "closeGapFilled";
    SessionGapEventType["fullGapFirstTouch"] = "fullGapFirstTouch";
    SessionGapEventType["fullGapFilled"] = "fullGapFilled";
})(SessionGapEventType || (SessionGapEventType = {}));
//# sourceMappingURL=SessionGapAnalyzerTypes.js.map